"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpIframe = void 0;
var react_1 = __importStar(require("react"));
var useViewedTracking_1 = require("../hooks/useViewedTracking");
var mp_context_1 = require("../context/mp-context");
var constants_1 = require("../constants");
var Skeletons_1 = require("./Skeletons");
var MpIframe = function (props) {
    var url = props.url, iframeTitle = props.iframeTitle, anchorStep = props.anchorStep, productType = props.productType, productId = props.productId;
    var iframeRef = (0, react_1.useRef)(null);
    var defaultHeight = (0, constants_1.getDefaultHeight)(productType, anchorStep);
    var _a = (0, react_1.useState)(defaultHeight), iframeHeight = _a[0], setIframeHeight = _a[1];
    var _b = (0, react_1.useState)(false), iframeLoaded = _b[0], setIframeLoaded = _b[1];
    var _c = (0, mp_context_1.useMpContext)(), mpStore = _c.mpStore, reportError = _c.reportError;
    var trackingParams = {
        anchorProduct: 'FLIGHT',
        anchorStep: anchorStep,
        productType: productType,
        actionName: 'viewed',
        productId: productId,
    };
    var onViewed = function () {
        mpStore.sendC360Event(trackingParams).catch(function (error) {
            reportError === null || reportError === void 0 ? void 0 : reportError(error, constants_1.MULTI_PRODUCT_ACTION_NAME);
        });
    };
    /* ####################################### */
    /* ### Messages coming from the iframe ### */
    /* ####################################### */
    (0, react_1.useEffect)(function () {
        var messageListener = function (e) {
            var _a;
            var message = e.data;
            if (message.type === 'MP_UPDATE_IFRAME_HEIGHT') {
                var payload = message.payload;
                var iframeHeight_1 = payload.iframeHeight, messageProductType = payload.productType;
                if (e.source === ((_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow) &&
                    messageProductType === productType) {
                    setIframeHeight(iframeHeight_1);
                }
            }
        };
        window.addEventListener('message', messageListener);
        return function () { return window.removeEventListener('message', messageListener); };
    }, [productType, anchorStep]);
    (0, useViewedTracking_1.useViewedTracking)({
        containerRef: iframeRef,
        onViewed: onViewed,
        hasLoaded: iframeLoaded,
    });
    var onIframeLoad = function () {
        setIframeLoaded(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        !iframeLoaded && (react_1.default.createElement("div", { style: {
                height: iframeHeight,
                width: '100%',
                overflow: 'hidden',
            } },
            react_1.default.createElement(Skeletons_1.Skeletons, { height: iframeHeight }))),
        react_1.default.createElement("iframe", { title: iframeTitle, src: url, id: iframeTitle, style: {
                height: iframeHeight,
                width: '100%',
                border: 0,
                visibility: iframeLoaded ? 'visible' : 'hidden',
            }, ref: iframeRef, onLoad: onIframeLoad })));
};
exports.MpIframe = MpIframe;
